import { Extension as p } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { Plugin as y, PluginKey as g } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { DEFAULT_FONT_SIZE as F } from "../../constants/default-styles.mjs";
import { unsetTextStyleAttribute as h } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
const T = new g("defaultFontSize"), x = p.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"],
      defaultFontSize: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (e) => e.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: n }) => n().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ tr: e, state: n, dispatch: d }) => h("fontSize", n, e, d)
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.defaultFontSize;
    return e ? [
      new y({
        key: T,
        appendTransaction: (n, d, o) => {
          if (!n.some((r) => r.docChanged))
            return null;
          const u = o.tr;
          let l = !1;
          return o.doc.descendants((r, i) => {
            if (!r.isText)
              return;
            const s = o.doc.resolve(i).parent, f = s.type.name === "paragraph", c = s.type.name === "listItem", m = s.type.name === "heading";
            if (!f && !c || m)
              return;
            const t = r.marks.find((a) => a.type.name === "textStyle");
            if (!(t == null ? void 0 : t.attrs.fontSize)) {
              const a = i, z = i + r.nodeSize, S = o.schema.marks.textStyle.create({
                ...t == null ? void 0 : t.attrs,
                fontSize: e
              });
              u.addMark(a, z, S), l = !0;
            }
          }), l ? u : null;
        }
      })
    ] : [];
  }
}), A = (e) => x.configure({
  defaultFontSize: e != null && e.clearable ? null : F
});
export {
  A as createFontSizeExtension
};
